import { useMutation } from '@tanstack/react-query';
import { UsersApi } from 'services/users/users.api';

export const usePostUserDetails = () => {
  return useMutation({
    mutationFn: UsersApi.putUserDetails,
  });
};
